import { Suspense, lazy, useState } from "react";
import { Box } from "@mui/system";
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./Topbar";
import GlobalLoader from "../../components/GlobalLoader";
import SidebarComponent from "./Sidebar";
import { useSelector } from "react-redux";
import { moduleName } from "../../utils/moduleName";
import { findUserAccess } from "../../utils/UserAccess";
import ScratchEventHistory from "../scratchEvent/scratch-event-history";

// const BillStatements = lazy(() => import("../invoices/BillStatements"));
const ScratchEventForm = lazy(() => import("../scratchEvent/ScratchEventForm"));
const ScratchEvent = lazy(() => import("../scratchEvent"));
const DecryptComponent = lazy(() => import("../../components/DecryptComponent"));
const SubscriptionForm = lazy(() => import("../subscription/SubscriptionForm"));
const SubscriptionHistory = lazy(() => import("../subscription/subscription-history"));
const BuyBonusList = lazy(() => import("../buyBonusList"));
const ProfileForm = lazy(() => import("../login/ProfileForm"));
const Bonus = lazy(() => import("../bonus"));
const Referral = lazy(() => import("../customers/referral"));
const Profile = lazy(() => import("../login/Profile"));
const Invoices = lazy(() => import("../invoices"));
const InvoiceOverview = lazy(() => import("../invoices/InvoiceOverview"));
const BillOverview = lazy(() => import("../invoices/BillOverview"));
const BillTable = lazy(() => import("../invoices/BillTable"));
const InvoiceForm = lazy(() => import("../invoices/InvoiceForm"));
const ReturnInvoiceForm = lazy(() => import("../invoices/ReturnInvoiceForm"));
const InvoiceViw = lazy(() => import("../invoices/InvoiceViw"));
const Distributors = lazy(() => import("../distributors"));
const DistributorForm = lazy(() => import("../distributors/DistributorForm"));
const DistributorDashboard = lazy(() => import("../distributors/DistributorDashboard"));
const Users = lazy(() => import("../users"));
const UserRole = lazy(() => import("../users/UserRole"));
const Operators = lazy(() => import("../operators"));
const OperatorForm = lazy(() => import("../operators/OperatorForm"));
const OperatorDashboard = lazy(() => import("../operators/OperatorDashboard"));
const Dashboard = lazy(() => import("../dashboard"));
const Advertises = lazy(() => import("../advertises"));
const Locations = lazy(() => import("../locations"));
const LocationForm = lazy(() => import("../locations/LocationForm"));
const LocationDashboard = lazy(() => import("../locations/LocationDashboard"));
const LocationDashboardListing = lazy(() => import("../locations/LocationDashboardListing"));
const Customers = lazy(() => import("../customers"));
const Transactions = lazy(() => import("../transactions"));
const Kiosk = lazy(() => import("../kiosks"));
const KioskModalList = lazy(() => import("../kiosks/KioskModalList"));
// const GenerateKiosk = lazy(() => import("../kiosks/GenerateKiosk"));
// const Statement = lazy(() => import("../statement"));
const Settings = lazy(() => import("../settings"));

const PromoReferral = lazy(() => import("../promoReferral"));
const PromoReferralForm = lazy(() => import("../promoReferral/PromoReferralForm"));
const CollectionInvoiceView = lazy(() => import("../collectionInvoice/CollectionInvoiceView"));
const CollectionInvoice = lazy(() => import("../collectionInvoice"));
const MgmList = lazy(() => import("../mgmList"));
const FishJackpot = lazy(() => import("../fishJackpot"));
const Subscription = lazy(() => import("../subscription"));
const CouponCode = lazy(() => import("../couponCode"));
const CouponCodeForm = lazy(() => import("../couponCode/CouponCodeForm"));
const CouponPlayers = lazy(() => import("../couponCode/coupon-players"));
const LoginHistory = lazy(() => import("../loginHistory"));

export default function Layout() {
  const [toggled, setToggled] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  const {
    promoCode,
    collectionInvoice,
    mgmList,
    fishJackpot,
    buyBonusList,
    subscription,
    scratchEvent,
    couponCode,
    loginHistory
  } = moduleName;

  const UserAccess = (value) => {
    return findUserAccess(value, user.userRole);
  };
  return (
    <Box sx={{ display: "flex", flexGrow: 1, width: "100%", height: "100%" }}>
      <Box className={`${toggled ? "toggled" : ""}`}>
        <SidebarComponent toggled={toggled} handleToggleSidebar={handleToggleSidebar} />
      </Box>
      <Box
        sx={{ minWidth: 0, flex: "0 1 auto", overflowY: "auto" }}
        width="100%"
        height="100%"
        className="respBottomSpace"
      >
        <Topbar handleToggleSidebar={handleToggleSidebar} />
        <Suspense fallback={<GlobalLoader />}>
          <Routes>
            <Route exact path="/" element={<Dashboard />} />
            {UserAccess("invoice_list") && <Route path="/invoices-list" element={<Invoices />} />}
            {UserAccess("invoice_list") && <Route exact path="/invoices-overview" element={<InvoiceOverview />} />}
            {UserAccess("view_bill") && <Route path="/payable-list" element={<BillTable />} />}
            {/* {UserAccess("view_bill") && <Route path="/payable-statements" element={<BillStatements />} />} */}
            {UserAccess("view_bill") && <Route exact path="/payable-overview" element={<BillOverview />} />}
            {UserAccess("invoice_create") && <Route exact path="/invoices/add" element={<InvoiceForm />} />}
            {UserAccess("invoice_create") && <Route exact path="/invoices/return" element={<ReturnInvoiceForm />} />}
            {UserAccess("invoice_view") && <Route exact path="/invoices/:id" element={<InvoiceViw />} />}

            {UserAccess("distributor_list") && <Route path="/distributors" element={<Distributors />} />}
            {UserAccess("distributor_add") && <Route exact path="/distributors/add" element={<DistributorForm />} />}
            {UserAccess("distributor_edit") && (
              <Route exact path="/distributors/edit/:id" element={<DistributorForm />} />
            )}
            {UserAccess("distributor_view") && (
              <Route exact path="/distributors/:id" element={<DistributorDashboard />} />
            )}
            {UserAccess("user_list") && <Route exact path="/users" element={<Users />} />}
            {(user?.userType === "superAdmin" || user?.userType === "admin" || user?.userType === "operator") && (
              <Route path="/users/role/:id" element={<UserRole />} />
            )}
            {UserAccess("operator_list") && <Route exact path="/operators" element={<Operators />} />}
            {UserAccess("operator_add") && <Route exact path="/operators/add" element={<OperatorForm />} />}
            {UserAccess("operator_edit") && <Route exact path="/operators/edit/:id" element={<OperatorForm />} />}
            {UserAccess("operator_view") && <Route exact path="/operators/:id" element={<OperatorDashboard />} />}
            {UserAccess("location_list") && <Route exact path="/locations" element={<Locations />} />}
            {UserAccess("location_add") && <Route exact path="/locations/add" element={<LocationForm />} />}
            {UserAccess("location_edit") && <Route exact path="/locations/edit/:id" element={<LocationForm />} />}
            {UserAccess("location_view") && <Route exact path="/locations/:id" element={<LocationDashboard />} />}
            {UserAccess("location_view") && (
              <Route exact path="/locations/:id/listing" element={<LocationDashboardListing />} />
            )}
            {UserAccess("customer_list") && <Route exact path="/customers" element={<Customers />} />}
            {UserAccess("transaction_list") && <Route exact path="/transactions" element={<Transactions />} />}
            {UserAccess("advertisement_list") && <Route exact path="/advertises" element={<Advertises />} />}
            {UserAccess("kiosk_model_list_tId") && <Route exact path="/kiosks" element={<Kiosk />} />}
            {UserAccess("kiosk_model_list") && <Route exact path="/kiosks/modal" element={<KioskModalList />} />}
            {UserAccess("bonus_data") && <Route exact path="/bonus" element={<Bonus />} />}
            {UserAccess("bonus_data") && <Route exact path="/referral" element={<Referral />} />}
            {user?.userType === "superAdmin" && <Route exact path="/settings" element={<Settings />} />}
            {user?.userType === "superAdmin" && (
              <Route exact path="/login-history" element={<LoginHistory name={loginHistory} />} />
            )}

            {UserAccess("promo_offer_list") && (
              <Route exact path="/promo-referral" element={<PromoReferral name={promoCode} />} />
            )}
            {UserAccess("promo_offer_create") && (
              <Route exact path="/promo-referral/add" element={<PromoReferralForm name={promoCode} />} />
            )}
            {UserAccess("promo_offer_edit") && (
              <Route exact path="/promo-referral/edit/:id" element={<PromoReferralForm name={promoCode} />} />
            )}
            {UserAccess("collection_invoice_list") && (
              <Route exact path="/collection-invoice" element={<CollectionInvoice name={collectionInvoice} />} />
            )}
            {UserAccess("collection_invoice_get") && (
              <Route
                exact
                path="/collection-invoice/:id"
                element={<CollectionInvoiceView name={collectionInvoice} />}
              />
            )}
            {UserAccess("mgm_list") && <Route exact path="/mgm-list" element={<MgmList name={mgmList} />} />}
            {UserAccess("fish_jackpot_list") && (
              <Route exact path="/fish-jackpot" element={<FishJackpot name={fishJackpot} />} />
            )}
            {UserAccess("bonus_purchase_list") && (
              <Route exact path="/buy-bonus-list" element={<BuyBonusList name={buyBonusList} />} />
            )}

            {/* {UserAccess("kiosk_model_generate_tId") && (
              <Route exact path="/kiosks/generate" element={<GenerateKiosk />} />
            )} */}
            {/* {UserAccess("statement_list") && <Route exact path="/statements" element={<Statement />} />} */}
            <Route exact path="/profile" element={user?.userType === "superAdmin" ? <ProfileForm /> : <Profile />} />
            {UserAccess("subscription_list") && (
              <Route exact path="/subscription" element={<Subscription name={subscription} />} />
            )}
            {UserAccess("subscription_list") && (
              <Route exact path="/subscription-history" element={<SubscriptionHistory name={subscription} />} />
            )}
            {UserAccess("subscription_create") && (
              <Route exact path="/subscription/add" element={<SubscriptionForm name={subscription} />} />
            )}
            {UserAccess("subscription_edit") && (
              <Route exact path="/subscription/edit/:id" element={<SubscriptionForm name={subscription} />} />
            )}
            {UserAccess("scratch_event_list") && (
              <Route exact path="/scratch-event" element={<ScratchEvent name={scratchEvent} />} />
            )}
            {UserAccess("scratch_event_list") && (
              <Route exact path="/scratch-event-history" element={<ScratchEventHistory name={scratchEvent} />} />
            )}
            {UserAccess("scratch_event_create") && (
              <Route exact path="/scratch-event/add" element={<ScratchEventForm name={scratchEvent} />} />
            )}
            {UserAccess("scratch_event_edit") && (
              <Route exact path="/scratch-event/edit/:id" element={<ScratchEventForm name={scratchEvent} />} />
            )}
            {/* {process.env.REACT_APP_DECRYPT_CODE === "true" && ( */}
            <Route exact path="/decrypt" element={<DecryptComponent />} />
            {/* )} */}
            {UserAccess("coupon_code_list") && (
              <Route exact path="/coupon-code" element={<CouponCode name={couponCode} />} />
            )}
            {UserAccess("coupon_code_create") && (
              <Route exact path="/coupon-code/add" element={<CouponCodeForm name={couponCode} />} />
            )}
            {UserAccess("coupon_code_list") && (
              <Route exact path="/coupon-code/players" element={<CouponPlayers name={couponCode} />} />
            )}
            {process.env.REACT_APP_DECRYPT_CODE === "true" && (
              <Route exact path="/decrypt" element={<DecryptComponent />} />
            )}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Box>
    </Box>
  );
}
